import { useEffect, useState } from "react";
import { fetchAllServices } from 'API';
import EditServiceModal from 'Components/Services/EditServiceModal'
import AddServiceModal from 'Components/Services/AddServiceModal'
import ServiceStatusButton from 'Components/Services/ServiceStatusButton'

const ManageServices = () => {

    const [serviceData, setServiceData] = useState([]);
    const [selectedService, setSelectedService] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [open, setOpen] = useState(false);

    const handleStatusChange = (id, newStatus) => {
        setServiceData(prev =>
            prev.map(service =>
                service.id === id
                    ? { ...service, status: newStatus }
                    : service
            )
        );
    };

    const handleEdit = (service) => {
        setSelectedService(service);
        setOpen(true);
    }


    useEffect(() => {
        const loadServices = async () => {
            const services = await fetchAllServices();
            setServiceData(services);

        }
        loadServices();
    }, []);

    return (
        <div className=" w-[90%] space-y-6 flex flex-col items-center justify-between m-auto">
            <div className="flex flex-col items-center justify-between">
                <div>
                    <h1 className="text-2xl font-semibold text-center text-gray-900 mt-5">
                        Manage your services
                    </h1>
                    <p className="text-sm text-gray-500 mt-2">
                        Your services will be displayed on your website.
                    </p>
                </div>

                <button onClick={() => setOpenAddModal(true)} className="rounded-xl bg-blue-600 px-5 py-2.5 mt-10 text-sm font-medium text-white hover:bg-blue-700 transition">
                    + Add a service
                </button>
            </div>

            {/* Services Table */}
            <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                <table className="w-full text-sm ">
                    <thead className="bg-gray-50 text-gray-600">
                        <tr>
                            <th className="px-4 py-3 text-left font-medium">SN</th>
                            <th className="px-4 py-3 text-left font-medium">Service Name</th>
                            <th className="px-4 py-3 text-left font-medium">Description</th>
                            <th className="px-4 py-3 text-left font-medium">Price</th>
                            <th className="px-4 py-3 text-left font-medium">Estimate Time</th>
                            <th className="px-4 py-3 text-left font-medium w-[170px]">Status</th>
                            <th className="px-4 py-3 text-left font-medium">Actions</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y">
                        {serviceData.map((service, index) => (
                            <tr key={service.id} className="hover:bg-gray-50">
                                <td className="px-4 py-3">{index + 1}</td>
                                <td className="px-4 py-3">{service.name}</td>
                                <td className="px-4 py-3">{service.description}</td>
                                <td className="px-4 py-3">$ {service.price} </td>
                                <td className="px-4 py-3">{service.time_taken} mins</td>
                                <td className="px-4 py-3">
                                    <ServiceStatusButton
                                        serviceId={service.id}
                                        status={service.status}
                                        onStatusChange={handleStatusChange}
                                    />
                                </td>
                                <td className="px-4 py-3 w-[170px]">
                                    <button onClick={() => { handleEdit(service) }} className="rounded-lg bg-blue-600 px-4 mx-1 py-2 text-sm text-white hover:bg-blue-700">
                                        Edit
                                    </button>
                                    <button className="rounded-lg bg-red-500 px-4 py-2 text-sm text-white hover:bg-red-700">
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modals Defined Here */}
            <EditServiceModal
                open={open}
                onClose={() => setOpen(false)}
                serviceData={selectedService}
                onServiceUpdated={(updatedService) => {
                    setServiceData(prev =>
                        prev.map(s => (s.id === updatedService.id ? updatedService : s))
                    );
                }}
            />

            <AddServiceModal
                open={openAddModal}
                onClose={() => setOpenAddModal(false)}
                onServiceUpdated={(newService) => {
                    setServiceData(prev => [...prev, newService]);
                }}
            />
        </div>
    );
};

export default ManageServices;
